import * as types from './mutation-types';

export default {
  [types.SET_DESKTOP_MODE](state, mode) {
    state.isDesktop = mode;
  },
  [types.SET_MENU](state, menu) {
    state.menu = menu;
  },
};
